import {btbIndustry, ratioMaxLengthMap, designSizeOptions} from './constants.js';

export const getMaxLength = e => {
    const {
        ext: {industryList},
        formData: {templateGroup: {industry, sizeControl}},
        config: {name}
    } = e;
    const isBtB = industryList.length
        && btbIndustry.includes(industryList.find(item => item.value === industry.value)?.label);
    const ratio = sizeControl.value.ratio;

    const ratioMaxLength = isBtB
        ? ratioMaxLengthMap.btb[name]
        : (ratioMaxLengthMap[ratio] ? ratioMaxLengthMap[ratio][name] : ratioMaxLengthMap.base[name]);

    return ratioMaxLength;
};

export const getTplOptions = e => {
    const btbSize = ['3:2', '1:1', '3:1', '9:16'];
    const otherSize = ['16:9', '1:1', '3:4', '3:2', '3:1', '9:16'];
    const {ext: {industryList}, formData: {templateGroup: {industry}}} = e;
    const isBtB = industryList.length
        && btbIndustry.includes(industryList.find(item => item.value === industry.value)?.label);
    const sizeOptions = designSizeOptions.filter(option =>
        (isBtB ? btbSize : otherSize).includes(option.value)
    );

    return sizeOptions;
};

export const checkValueExists = (arr, value) => {
    return arr.some(item => item.value === value);
};

export const getIntelFormCanSubmit = e => {
    // 一键出图可提交特殊判断: 有参考图片或者背景prompt, 都可提交
    const {bgControl, referPic} = e;
    if (referPic?.image?.[0]?.url) {
        return true;
    }
    if (bgControl?.value?.prompt) {
        return true;
    }
    return false;
};